"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subAppCCLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ReactDOM = __importStar(require("react-dom"));
// providers
const translations_1 = require("../../translations");
const featureFlag_1 = require("../../featureFlag");
const eventBus_1 = require("../../eventBus");
const tracker_1 = require("../../tracker");
const providers_1 = require("./providers");
const initializer_1 = require("../../initializer");
/**
 * Builds the subapp config object and injects it
 * into window.globals so it can be shared with frame
 *
 * The rendering of the subapp in the DOM is delegated
 * to the DynamicLoader
 */
const subAppCCLoader = async ({ id, API, app: App, translationsConfig, trackerConfig, reducers = {}, }) => {
    const AppWithProviders = ({ history, oldData }) => ((0, jsx_runtime_1.jsx)(providers_1.SubAppCCProviders, { history: history, children: (0, jsx_runtime_1.jsx)(App, { oldData: oldData }) }));
    const config = {
        verticalId: id,
        entrypoint: async (domElement, _store, _history, _initializedFeatures, _externalComponents, data) => {
            (0, featureFlag_1.setFeatureFlag)(data.featureFlag);
            (0, eventBus_1.setGlobalEventBus)(data.eventBus);
            // TODO: Fix could be undefined. Type issue
            if (data.usd) {
                initializer_1.UsdManager.loadFromData(data.usd);
            }
            if (trackerConfig) {
                await (0, tracker_1.initAllTrackers)(trackerConfig, API, initializer_1.GenericUSDManager, initializer_1.Authenticator);
                tracker_1.trackers.wrapupTracker && (0, tracker_1.addCommonInfoToWrapupTracker)(trackerConfig);
            }
            if (translationsConfig) {
                await (0, translations_1.initTranslationsWithInitialTranslationsAndConfig)(API, translationsConfig, data.translations?.web, data.translations?.config);
            }
            ReactDOM.render((0, jsx_runtime_1.jsx)(AppWithProviders, { history: data.history || _history, oldData: { store: _store, initializedFeatures: _initializedFeatures, externalComponents: _externalComponents, history: _history } }), domElement);
        },
        wrapupConfig: {},
        reducers,
    };
    window.globals = window.globals || {};
    window.globals[id] = config;
    window.globalPromises?.[id]?.();
};
exports.subAppCCLoader = subAppCCLoader;
//# sourceMappingURL=index.js.map